import type { BBox } from 'geojson';

export type Bounds = [number, number, number, number];

export const bboxToBounds = (bbox: BBox): Bounds => [
  (bbox as number[])[0],
  (bbox as number[])[1],
  (bbox as number[])[2],
  (bbox as number[])[3],
];

// export const fromTurfPoint = (point: helpers.Point): GeoJSONPoint => ({
//   type: 'Point',
//   coordinates: [point.coordinates[0], point.coordinates[1]],
// });

export const isLatLong = (value: unknown[]): value is [number, number] =>
  value.length === 2 &&
  typeof value[0] === 'number' &&
  typeof value[1] === 'number';
